export const getUnshardedTeamCentralGraphqlUrl: any = (baseUrl: string) =>
	`${baseUrl}/watermelon/graphql`;
